import { TipsMapType } from '../index';
export const competitorAddSortGameTips: TipsMapType = {
  en: `After modification of competitors, it applies to this account only and takes effect on this page only, and does not affect other users' competitor list.`,
  zh: '竞品修改后，仅针对本用户且仅在竞品页生效，不影响其他用户的竞品列表。',
};

export const competitorKeywordTips: TipsMapType = {
  en: `The keyword data statistics in this place adopt the original keyword list, which has not undergone the subsequent synthetic keyword processing, namely, it does not integrate synonymous keywords.`,
  zh: '此处关键词数据统计使用的原始关键词表，未经过后期的合成关键词处理，即不会合并同义关键词。',
};

export const competitorPositiveTopicTips: TipsMapType = {
  en: `Positive topic: After classifying all mentions by topic, calculate the mentions and sentiment score of each topic. Topics with an sentiment score higher than 3.5 are positive topics. Here shows the top 2 positive topics based on mentions of each game.`,
  zh: '正面话题：将所有声量按话题分类后，计算各个话题对应评论的声量及情感分。情感分高于 3.5 的话题为正面话题。本栏目将展示每个游戏声量排行前2的正面话题。',
};

export const competitorNegativeTopicTips: TipsMapType = {
  en: `Negative topic: After classifying all mentions by topic, calculate the mentions and sentiment score of each topic. Topics with an sentiment score lower than 2.5 are negative topics. Here shows the top 2 negative topics based on mentions of each game.`,
  zh: '负面话题：将所有声量按话题分类后，计算各个话题对应评论的声量及情感分。情感分低于 2.5 的话题为负面话题。本栏目将展示每个游戏声量排行前2的负面话题。',
};
